import React from "react";
import { useNavigate } from "react-router-dom";

interface Notification {
  id: number | string;
  text: string;
  date: string;
  icon?: string;
}

const NotificationModal = ({
  notifications,
  onClose,
}: {
  notifications: Notification[];
  onClose: () => void;
}) => {
  const navigate = useNavigate();
  const visibleCount = 5;

  const handleReadMore = () => {
    onClose();
    void navigate("/notifications");
  };

  return (
    <>
      <div className="fixed inset-0 z-[999]" onClick={onClose} />
      <div
        className="absolute top-full right-0 mt-2 bg-white rounded-lg shadow-[0_4px_8px_rgba(0,0,0,0.1)] w-[360px] z-[1000]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="p-[20px_10px] rounded-lg">
          {notifications.length === 0 ? (
            <div className="py-8 px-4 text-center">
              <p className="text-sm text-[#999]">通知がありません</p>
            </div>
          ) : (
            <>
              {notifications.slice(0, visibleCount).map((notification, index) => (
                <div
                  key={notification.id}
                  className={`py-2.5 px-[15px] ${index < visibleCount - 1 || visibleCount < notifications.length ? "border-b border-[#ddd]" : ""}`}
                >
                  <div className="flex gap-2.5">
                    <img
                      src={notification.icon ?? "/images/activity_icon.svg"}
                      alt=""
                      className="w-5 h-5"
                      onError={(e) => {
                        const target = e.target as HTMLImageElement;
                        target.src = "/images/activity_icon.svg";
                      }}
                    />
                    <p className="text-sm text-[#333] m-0">{notification.text}</p>
                  </div>
                  <span className="text-xs text-[#999] text-right block mt-2">
                    {notification.date}
                  </span>
                </div>
              ))}
              {visibleCount < notifications.length && (
                <div className="flex justify-center mt-4">
                  <button
                    className="flex justify-center items-center bg-white text-[#333] border border-[#333] rounded-full py-2.5 px-6 cursor-pointer text-sm font-medium hover:bg-[#f5f5f5] hover:border-[#2585d2] hover:text-[#2585d2] transition-all duration-200 shadow-sm hover:shadow-md"
                    onClick={handleReadMore}
                  >
                    もっと見る
                  </button>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default NotificationModal;
